import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, computed, inject } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { SvgViewerComponent } from 'src/app/shared/components/svg-viewer/svg-viewer.component';
import { getProductInfo } from 'src/app/shared/constants/product.constants';
import { KeyAmount } from 'src/app/shared/models/interface/concretes/key-amount.interface';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';

@Component({
  selector: 'app-vyv-summary',
  standalone: true,
  imports: [CurrencyPipe, SvgViewerComponent],
  templateUrl: './vyv-summary.component.html',
  styles: [],
})
export class VyvSummaryComponent implements OnInit {
  public resource = inject(AppResource)['resource'];
  store = inject(CombinedStore);

  ngOnInit(): void {
    // ACTIVATE STORE SUMMARY
    const productName = getProductInfo(this.store.path())!.name;
    this.svg = new SvgVM(`assets/common/offerCustomize/${productName}.svg`, 'white');
  }

  svg!: SvgVM;

  summary = computed(() => {
    const summary = [] as KeyAmount[];
    const offer = this.store.summaryOffer();
    const productInfo = getProductInfo(this.store.path());

    // Add base package if available
    if (offer.package) {
      summary.push({
        key: 'Assurance habitation ' + (productInfo?.name || ''),
        value: String(offer.package.monthlyPremiumAmountIncludingTax!),
      });
    }

    // Add options
    if (offer.options && offer.options.length > 0) {
      summary.push(...offer.options);
    }

    return summary;
  });

  isNumber(value: string): boolean {
    return !isNaN(Number(value));
  }

  summaryAmount = computed(() => {
    // Logic to compute the summary amount
    return this.summary()
      .filter((item) => item.value !== 'Inclus')
      .reduce((total, item) => total + (Number(item.value) ?? 0), 0);
  });
}
